export class SelfAssessmentT3ListDto {
  id: number;
  rulebookRuleID: string;
  title: string;
  ruleBook: string;
  part: string;
  ruleId: string;
  owner: string;
  assessmentStatus: string;
  complianceStatus: string;
  assessmentDate?: Date | null;
  reviewDate?: Date | null;
  lbgImpact: boolean;
  rfbImpact: boolean;
  lbcmImpact: boolean;
  nextAssessmentDueDate?: Date | null;

  constructor() {
    this.id = 0;
    this.rulebookRuleID = '';
    this.title = '';
    this.ruleBook = '';
    this.part = '';
    this.ruleId = '';
    this.owner = '';
    this.assessmentStatus = '';
    this.complianceStatus = '';
    this.lbcmImpact = true;
    this.lbgImpact = true;
    this.rfbImpact = true;
  }
}

export class SelfAssessmentT3ViewModel {
  data: SelfAssessmentT3ListDto[];
  totalCount: number;
  fromDate: Date;
  toDate: Date;

  constructor() {
    this.data = [];
    this.totalCount = 0;
    this.fromDate = new Date();
    this.toDate = new Date();
  }
}
